import $ from 'jquery';

class Aria {
  constructor() {
    // this.team();
    this.transaction();
  }

  // team() {
  //   this.memberImage = $('.js-team-member-image');

  //   this.memberImage.on('mouseenter focus', e => {
  //     const self = $(e.currentTarget);
  //     const shortBio = self.find('.js-team-member-sb');

  //     self.attr('aria-expanded', true);
  //     shortBio.attr('aria-hidden', false);
  //   });

  //   this.memberImage.on('mouseleave blur', e => {
  //     const self = $(e.currentTarget);
  //     const shortBio = self.find('.js-team-member-sb');

  //     self.attr('aria-expanded', false);
  //     shortBio.attr('aria-hidden', true);
  //   });
  // }

  transaction() {
    this.transactionItem = $('.js-tr-post-inner');

    this.transactionItem.on('mouseenter focus', e => {
      const self = $(e.currentTarget);
      const itemCard = self.find('.js-tr-post-card');

      self.attr('aria-expanded', true);
      itemCard.attr('aria-hidden', false);
    });

    this.transactionItem.on('mouseleave blur', e => {
      const self = $(e.currentTarget);
      const itemCard = self.find('.js-tr-post-card');

      self.attr('aria-expanded', false);
      itemCard.attr('aria-hidden', true);
    });
  }
}

export default new Aria();



// WEBPACK FOOTER //
// ./src/scripts/modules/aria.js